import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
  screenRoot: {
    flex: 1,
    backgroundColor: "#f5f9ff",
  },
  container: {
    flex: 1,
    width: "100%",
    paddingHorizontal: 36,
    paddingTop: 24,
  },
  content: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 36,
  },
  headerBlock: {
    marginBottom: 16,
  },
  breadcrumbRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    marginBottom: 4,
  },
  breadcrumbLink: {
    borderRadius: 4,
  },
  breadcrumbLinkHover: {
    opacity: 0.86,
  },
  breadcrumbLinkPressed: {
    opacity: 0.7,
  },
  breadcrumbLinkText: {
    fontSize: 12,
    fontWeight: "600",
    color: "#005cbc",
  },
  breadcrumbSeparator: {
    fontSize: 12,
    fontWeight: "500",
    color: "#818181",
  },
  breadcrumbCurrent: {
    fontSize: 12,
    fontWeight: "500",
    color: "#656565",
  },
  title: {
    fontSize: 28,
    fontWeight: "700",
    color: "#2d2d2d",
    lineHeight: 34,
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  subtitle: {
    marginTop: 2,
    fontSize: 13,
    color: "#818181",
  },
  statusBanner: {
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginBottom: 16,
    borderWidth: 0,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  statusBannerIcon: {
    marginTop: 2,
  },
  statusBannerInfo: {
    backgroundColor: "#f3f7fd",
    borderColor: "#daeefa",
  },
  statusBannerSuccess: {
    backgroundColor: "#1b6e1f",
  },
  statusBannerError: {
    backgroundColor: "#ffe5de",
    borderColor: "#f4b6a7",
  },
  statusBannerText: {
    fontSize: 13,
    fontWeight: "600",
    color: "#2d2d2d",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  statusBannerSuccessText: {
    color: "#ffffff",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  statusBannerLink: {
    color: "#ffffff",
    textDecorationLine: "underline",
    fontWeight: "700",
  },
  existingCard: {
    backgroundColor: "#ffffff",
    borderRadius: 12,
    paddingVertical: 20,
    paddingHorizontal: 24,
    marginBottom: 20,
    borderWidth: 1,
    borderColor: "#daeefa",
    ...(Platform.OS === "web"
      ? { background: "linear-gradient(180deg, #F3F7FD 0%, #FFFFFF 50%)" as any }
      : {}),
  },
  existingCardHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    marginBottom: 6,
  },
  existingIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: "#daeefa",
    alignItems: "center",
    justifyContent: "center",
  },
  panel: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    padding: 24,
    marginBottom: 16,
    shadowColor: "rgba(0,94,192,0.08)",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 2,
  },
  panelTitle: {
    fontSize: 15,
    fontWeight: "700",
    color: "#2d2d2d",
    marginBottom: 4,
  },
  panelSubtitle: {
    fontSize: 13,
    color: "#585858",
    lineHeight: 20,
    marginBottom: 14,
  },
  searchWrap: {
    position: "relative",
    marginBottom: 14,
  },
  searchIcon: {
    position: "absolute",
    left: 14,
    top: 13,
    zIndex: 2,
  },
  searchInput: {
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 8,
    paddingLeft: 40,
    paddingRight: 14,
    paddingVertical: 10,
    height: 44,
    fontSize: 14,
    color: "#2d2d2d",
    fontFamily: Platform.select({
      ios: "Inter-Regular",
      android: "Inter-Regular",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Regular",
    }),
  },
  existingTicket: {
    borderWidth: 1,
    borderColor: "#E6E6E6",
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 14,
    marginBottom: 6,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    ...(Platform.OS === "web"
      ? { background: "#ffffff", cursor: "pointer", transitionProperty: "border-color, box-shadow", transitionDuration: "120ms" } as any
      : { backgroundColor: "#ffffff" }),
  },
  existingTicketHovered: {
    borderColor: "#82CDF8",
    shadowColor: "#005EC0",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 2,
  },
  existingTicketAttached: {},
  existingTicketBody: {
    flex: 1,
    minWidth: 0,
    paddingTop: 2,
  },
  cardHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  existingMetaRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    marginTop: 0,
    flexWrap: "wrap",
  },
  ticketId: {
    fontSize: 12,
    fontWeight: "700",
    color: "#005cbc",
    marginBottom: 4,
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  affectedButton: {
    backgroundColor: "#005CBC",
    borderRadius: 100,
    paddingHorizontal: 12,
    paddingVertical: 7,
    minWidth: 90,
    alignItems: "center",
  },
  affectedButtonDisabled: {
    backgroundColor: "#E6E6E6",
  },
  affectedButtonHover: {
    backgroundColor: "#034895",
  },
  affectedButtonPressed: {
    backgroundColor: "#023466",
  },
  affectedButtonText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#ffffff",
  },
  affectedButtonTextDisabled: {
    color: "#818181",
  },
  ticketTitle: {
    fontSize: 13,
    color: "#2d2d2d",
    fontWeight: "600",
    marginBottom: 6,
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  ticketMeta: {
    fontSize: 12,
    color: "#585858",
    fontFamily: Platform.select({
      ios: "Inter-Regular",
      android: "Inter-Regular",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Regular",
    }),
  },
  statusBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  statusDefault: {
    backgroundColor: "#ebebeb",
  },
  statusDefaultText: {
    color: "#585858",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  statusDefaultDot: {
    backgroundColor: "#585858",
  },
  statusProgress: {
    backgroundColor: "#e1e3fd",
  },
  statusProgressText: {
    color: "#7871e2",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  statusProgressDot: {
    backgroundColor: "#7871e2",
  },
  statusWaitingIt: {
    backgroundColor: "#fef1b9",
  },
  statusWaitingItText: {
    color: "#8b6508",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  statusWaitingItDot: {
    backgroundColor: "#8b6508",
  },
  statusWaitingUser: {
    backgroundColor: "#ffe9d1",
  },
  statusWaitingUserText: {
    color: "#cc6e16",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  statusWaitingUserDot: {
    backgroundColor: "#cc6e16",
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: "#585858",
  },
  statusBadgeText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#585858",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  formCardHeader: {
    marginBottom: 16,
  },
  formHeaderTitle: {
    fontSize: 16,
    fontWeight: "700",
    color: "#2d2d2d",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  formHeaderSubtitle: {
    fontSize: 12,
    color: "#818181",
    marginTop: 2,
  },
  formGrid: {
    flexDirection: Platform.OS === "web" ? "row" : "column",
    flexWrap: Platform.OS === "web" ? "wrap" : "nowrap",
    columnGap: 24,
    rowGap: 16,
    ...Platform.select({ web: { overflow: "visible" } as any, default: {} }),
  },
  fieldGroup: {
    marginBottom: 16,
    width: Platform.OS === "web" ? 420 : "100%",
    ...Platform.select({ web: { overflow: "visible" } as any, default: {} }),
  },
  fieldFull: {
    width: "100%",
    ...Platform.select({ web: { overflow: "visible" } as any, default: {} }),
  },
  label: {
    fontSize: 12,
    fontWeight: "600",
    color: "#585858",
    marginBottom: 6,
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  required: {
    color: "#c12c01",
  },
  optional: {
    fontSize: 11,
    color: "#818181",
    fontWeight: "400",
  },
  input: {
    height: 40,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 6,
    paddingHorizontal: 12,
    paddingVertical: Platform.OS === "ios" ? 11 : 9,
    fontSize: 14,
    color: "#2d2d2d",
    backgroundColor: "#ffffff",
    fontFamily: Platform.select({
      ios: "Inter-Regular",
      android: "Inter-Regular",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Regular",
    }),
  },
  inputFull: {
    width: "100%",
  },
  inputDisabled: {
    backgroundColor: "#f8f8f8",
    color: "#a8a8a8",
  },
  lockedBox: {
    height: 42,
    borderWidth: 1,
    borderColor: "#daeefa",
    borderRadius: 6,
    paddingHorizontal: 14,
    backgroundColor: "#f3f7fd",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  lockedBoxText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#2d2d2d",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  textarea: {
    minHeight: 120,
    textAlignVertical: "top",
    fontFamily: Platform.select({
      ios: "Inter-Regular",
      android: "Inter-Regular",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Regular",
    }),
  },
  fieldMetaRow: {
    marginTop: 6,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  helperText: {
    marginTop: 6,
    fontSize: 11,
    color: "#818181",
  },
  selectFieldOpen: {
    zIndex: 9999,
    ...Platform.select({ web: { position: "relative", overflow: "visible" } as any, default: {} }),
  },
  selectWrap: {
    position: "relative",
    ...Platform.select({ web: { overflow: "visible" } as any, default: {} }),
  },
  selectTrigger: {
    height: 40,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 6,
    backgroundColor: "#ffffff",
    paddingHorizontal: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  selectTriggerOpen: {
    borderColor: "#005cbc",
  },
  selectTriggerHover: {
    borderColor: "#7aa7d9",
    backgroundColor: "#fbfdff",
  },
  selectTriggerPressed: {
    backgroundColor: "#f3f7fd",
  },
  selectTriggerDisabled: {
    backgroundColor: "#f8f8f8",
  },
  selectTriggerText: {
    fontSize: 14,
    color: "#2d2d2d",
    fontFamily: Platform.select({
      ios: "Inter-Regular",
      android: "Inter-Regular",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Regular",
    }),
  },
  selectPlaceholderText: {
    color: "#9099aa",
  },
  selectTriggerTextDisabled: {
    color: "#a8a8a8",
  },
  selectMenu: {
    position: "absolute",
    top: 44,
    left: 0,
    right: 0,
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 8,
    overflow: "hidden",
    zIndex: 200,
    shadowColor: "rgba(58,58,58,0.08)",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 5,
    ...Platform.select({ web: { overflowY: "auto", overflowX: "hidden" } as any, default: {} }),
  },
  selectMenuItem: {
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  selectMenuItemActive: {
    backgroundColor: "#eff5fc",
  },
  selectMenuItemHover: {
    backgroundColor: "#f7faff",
  },
  selectMenuItemPressed: {
    backgroundColor: "#e8f0fb",
  },
  selectMenuItemText: {
    fontSize: 13,
    color: "#2d2d2d",
    fontFamily: Platform.select({
      ios: "Inter-Regular",
      android: "Inter-Regular",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Regular",
    }),
  },
  selectMenuItemTextActive: {
    color: "#005cbc",
    fontWeight: "700",
  },
  chipRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  chip: {
    borderWidth: 1,
    borderColor: "#d7dfec",
    backgroundColor: "#ffffff",
    borderRadius: 999,
    paddingHorizontal: 14,
    paddingVertical: 8,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  urgencyChip: {
    paddingHorizontal: 16,
  },
  chipActive: {
    borderColor: "#005cbc",
    backgroundColor: "#e8f0fb",
  },
  chipHover: {
    borderColor: "#9fbfe4",
    backgroundColor: "#f8fbff",
  },
  chipPressed: {
    backgroundColor: "#eef5fd",
    transform: [{ scale: 0.98 }],
  },
  urgencyDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  urgencyCritical: {
    backgroundColor: "#c12c01",
  },
  urgencyHigh: {
    backgroundColor: "#cc6e16",
  },
  urgencyMedium: {
    backgroundColor: "#fcc42b",
  },
  urgencyLow: {
    backgroundColor: "#a8a8a8",
  },
  chipText: {
    fontSize: 12,
    color: "#4b4b4b",
    fontWeight: "600",
    fontFamily: Platform.select({
      ios: "Inter-Bold",
      android: "Inter-Bold",
      web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
      default: "Inter-Bold",
    }),
  },
  chipTextActive: {
    color: "#034895",
    fontWeight: "700",
  },
  uploadBox: {
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: "#c0c0c0",
    borderRadius: 8,
    backgroundColor: "#f8f8f8",
    paddingVertical: 14,
    paddingHorizontal: 12,
  },
  uploadBoxHover: {
    borderColor: "#005cbc",
    backgroundColor: "#f3f7fd",
  },
  uploadBoxPressed: {
    backgroundColor: "#e8f0fb",
  },
  uploadText: {
    fontSize: 13,
    color: "#005cbc",
    fontWeight: "600",
    textAlign: "center",
  },
  attachmentChip: {
    marginTop: 8,
    borderWidth: 1,
    borderColor: "#ebebeb",
    borderRadius: 8,
    backgroundColor: "#f8f8f8",
    paddingHorizontal: 12,
    paddingVertical: 8,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  attachmentIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 6,
    backgroundColor: "#e8f0fb",
    alignItems: "center",
    justifyContent: "center",
  },
  attachmentIconText: {
    fontSize: 10,
    fontWeight: "700",
    color: "#005cbc",
  },
  attachmentTextWrap: {
    flex: 1,
    minWidth: 0,
  },
  attachmentName: {
    fontSize: 13,
    fontWeight: "600",
    color: "#2d2d2d",
  },
  attachmentSize: {
    fontSize: 11,
    color: "#818181",
  },
  removeAttachmentButton: {
    width: 28,
    height: 28,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  removeAttachmentButtonHover: {
    backgroundColor: "#eef2f7",
  },
  removeAttachmentButtonPressed: {
    backgroundColor: "#dfe7f1",
  },
  removeAttachmentText: {
    fontSize: 18,
    lineHeight: 20,
    color: "#656565",
  },
  customToggleTrack: {
    width: 60,
    height: 22,
    borderRadius: 17,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 4,
    justifyContent: "space-between",
  },
  customToggleTrackOn: {
    backgroundColor: "#034895",
  },
  customToggleTrackOff: {
    backgroundColor: "#d0d0d0",
  },
  customToggleThumb: {
    width: 18,
    height: 18,
    borderRadius: 13,
    backgroundColor: "#ffffff",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.18,
    shadowRadius: 2,
    elevation: 2,
  },
  customToggleLabel: {
    flex: 1,
    fontSize: 12,
    fontWeight: "700",
    textAlign: "center",
    includeFontPadding: false,
  },
  customToggleLabelOn: {
    color: "#ffffff",
  },
  customToggleLabelOff: {
    color: "#4b5563",
  },
  footerActions: {
    marginTop: 20,
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: "#ebebeb",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 8,
  },
  btnGhost: {
    borderRadius: 100,
    paddingHorizontal: 18,
    paddingVertical: 9,
    backgroundColor: "transparent",
  },
  btnGhostHover: {
    backgroundColor: "#eef2f7",
  },
  btnGhostPressed: {
    backgroundColor: "#dde5ef",
  },
  btnSecondary: {
    borderRadius: 100,
    paddingHorizontal: 18,
    paddingVertical: 9,
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: "#034895",
  },
  btnSecondaryHover: {
    backgroundColor: "#f3f7fd",
  },
  btnSecondaryPressed: {
    backgroundColor: "#e8f0fb",
  },
  btnPrimary: {
    borderRadius: 100,
    paddingHorizontal: 18,
    paddingVertical: 9,
    backgroundColor: "#034895",
  },
  btnPrimaryDisabled: {
    backgroundColor: "#C8D8EE",
  },
  btnPrimaryHover: {
    backgroundColor: "#0457ad",
  },
  btnPrimaryPressed: {
    backgroundColor: "#023466",
  },
  btnGhostText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#4b4b4b",
  },
  btnSecondaryText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#034895",
  },
  btnPrimaryText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#ffffff",
  },
  btnPrimaryTextDisabled: {
    color: "#EEF4FB",
  },
});

export default styles;
